import { AdTemplate } from 'models/AdTemplate';
import ResponsiveImageModel from 'components/Shared/Image/ResponsiveImage';
import { sizes } from 'components/Ad/sizes';
import warning from 'warning';

export interface Dimensions {
  height: number;
  width: number;
  responsive?: ResponsiveImageModel;
}

const dimensionsMap: {
  [key: number]: Dimensions;
} = {
  [AdTemplate.Medium]: {
    height: sizes.mediumAdPictureLargeHeight,
    width: sizes.mediumAdPictureLargeWidth,
    responsive: {
      srcSet: [
        {
          viewWidth: sizes.mediumAdPictureLargeWidth,
          width: sizes.mediumAdPictureLargeWidth,
          height: sizes.mediumAdPictureLargeHeight
        },
        {
          viewWidth: sizes.mediumAdPictureSmallWidth,
          width: sizes.mediumAdPictureSmallWidth,
          height: sizes.mediumAdPictureSmallHeight
        }
      ],
      sizes: `(min-width: 768px) ${sizes.mediumAdPictureSmallWidth}px, ${sizes.mediumAdPictureLargeWidth}px`
    }
  },
  [AdTemplate.PanoramaTwoThirds]: {
    height: sizes.panoramaTwoThirdsPictureHeight,
    width: sizes.panoramaTwoThirdsPictureWidth
  },
  [AdTemplate.PanoramaFull]: {
    height: sizes.panoramaImageAdHeight,
    width: sizes.panoramaImageAdWidth
  },
  [AdTemplate.PanoramaBrandContent]: {
    height: sizes.panoramaImageAdHeight,
    width: sizes.panoramaImageAdWidth
  },
  [AdTemplate.Leaderboard]: {
    height: sizes.leaderboardImageAdHeight,
    width: sizes.leaderboardImageAdWidth
  },
  [AdTemplate.LeaderboardLarge]: {
    height: sizes.leaderboardLargeAdHeight,
    width: sizes.leaderboardLargeAdWidth
  },

  [AdTemplate.R3Panorama]: {
    width: sizes.redPanoramaWidth,
    height: sizes.redPanoramaHeight
  },
  [AdTemplate.R3FullSize]: {
    width: sizes.redPanoramaWidth,
    height: sizes.redPanoramaHeight
  },
  [AdTemplate.R3HalfSize]: {
    width: sizes.redPanoramaWidth,
    height: sizes.redPanoramaHeight
  },
  [AdTemplate.R3Quarter]: {
    width: sizes.redPanoramaWidth,
    height: sizes.redPanoramaHeight
  }
};

export const pictureDimensions = (appearanceType: number) => {
  warning(
    Object.prototype.hasOwnProperty.call(dimensionsMap, appearanceType),
    `dimensionsMap is missing ${AdTemplate[appearanceType]}`
  );
  return dimensionsMap[appearanceType];
};
